import Model, { attr } from '@ember-data/model';
import type {
  AirbnbGuestDataException,
  AirbnbGuestDataStep,
} from 'uplisting-frontend/services/airbnb-guest-data-policy';

export default class AirbnbGuestDataAcknowledgementModel extends Model {
  @attr('string') step!: AirbnbGuestDataStep;
  @attr('string') exception!: AirbnbGuestDataException;
  @attr('string') reference?: string | null;
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'airbnb-guest-data-acknowledgement': AirbnbGuestDataAcknowledgementModel;
  }
}
